import { Card, Steps } from 'antd';
import LOCALS from 'commons/locals';
import { Trans } from 'react-i18next';
import { OmsOrder } from 'types/oms';
import useIsMobile from 'commons/hooks/useIsMobile';
import DualTimezoneTime from 'components/dual-timezone-time';
import { ORDER_STATUS_MAP } from 'constant/oms-order-status';

type OrderStepProps = {
  status: OmsOrder['status'];
  createTime: OmsOrder['createTime'];
  paymentTime: OmsOrder['paymentTime'];
  deliveryTime: OmsOrder['deliveryTime'];
  receiveTime: OmsOrder['receiveTime'];
  stockPlace?: string;
};

const stepCurrentMap = {
  [ORDER_STATUS_MAP.TO_BE_PAID]: 1,
  [ORDER_STATUS_MAP.TO_BE_DELIVERED]: 2,
  [ORDER_STATUS_MAP.DELIVERED]: 3,
  [ORDER_STATUS_MAP.COMPLETED]: 4,
  [ORDER_STATUS_MAP.CANCLED]: 1,
  [ORDER_STATUS_MAP.INVALID_ORDER]: 1,
  [ORDER_STATUS_MAP.REFUND_ORDER]: 1,
} as const;

const OrderStep = ({
  status,
  createTime,
  paymentTime,
  deliveryTime,
  receiveTime,
  stockPlace,
}: OrderStepProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return null;
  }

  return (
    <Card bodyStyle={{ padding: '16px' }}>
      <Steps
        progressDot
        current={stepCurrentMap[status as keyof typeof stepCurrentMap] || 1}
        items={[
          {
            title: <Trans i18nKey={LOCALS.order_submitted} />,
            description: (
              <DualTimezoneTime time={createTime} stockPlace={stockPlace} />
            ),
          },
          {
            title: <Trans i18nKey={LOCALS.order_paid} />,
            description: (
              <DualTimezoneTime time={paymentTime} stockPlace={stockPlace} />
            ),
          },
          {
            title: <Trans i18nKey={LOCALS.platform_delivery} />,
            description: (
              <DualTimezoneTime time={deliveryTime} stockPlace={stockPlace} />
            ),
          },
          {
            title: <Trans i18nKey={LOCALS.completed} />,
            description: (
              <DualTimezoneTime time={receiveTime} stockPlace={stockPlace} />
            ),
          },
        ]}
      />
    </Card>
  );
};

export default OrderStep;
